// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"antd-pro-components-antd-base-table-components-affix-v2-index-wrapper","hide":"antd-pro-components-antd-base-table-components-affix-v2-index-hide"};